import { Tabs } from "antd";
import React, { useState } from "react";
import { useDetailCustomer } from "hooks";
import CustomerSchedulesTable from "../Schedules/CustomerSchedulesTable";
import CustomerLocationTable from "./CustomerLocationTable";
import CustomerLocationTransport from "./CustomerLocationTransport";
import CustomerAuditLogsTable from "./CustomerAuditLogsTable";
import { CustomerLocationType } from "./utils";

const CustomerLocationTab = ({ customerId, ...props }) => {
  const [key, setKey] = useState("1");
  const { TabPane } = Tabs;

  const { data: customerData } = useDetailCustomer({
    customerId,
    params: { expand: "maker,checker" },
  });

  const customerCode = customerData?.code;

  return (
    <Tabs defaultActiveKey="1" onChange={e => setKey(e)}>
      <TabPane tab="Địa chỉ nhận mẫu" key="1">
        <CustomerLocationTable
          type={CustomerLocationType.RECEIVE}
          customerId={customerId}
        />
      </TabPane>
      <TabPane tab="Địa chỉ trả kết quả" key="2">
        <CustomerLocationTable
          type={CustomerLocationType.RETURN_RESULT}
          customerId={customerId}
        />
      </TabPane>
      <TabPane tab="Mốc thời gian" key="3">
        <CustomerLocationTable
          type={CustomerLocationType.LEAD_TIMES}
          customerId={customerId}
        />
      </TabPane>
      <TabPane tab="Lịch làm việc" key="4">
        <CustomerSchedulesTable
          type={CustomerLocationType.SCHEDULES}
          customerId={customerId}
        />
      </TabPane>
      <TabPane tab="Phân bổ ĐVVC" key="5">
        <CustomerLocationTransport customerId={customerId} />
      </TabPane>
      <TabPane tab="Lịch sử chỉnh sửa" key="6">
        <CustomerAuditLogsTable customerCode={customerCode} />
      </TabPane>
    </Tabs>
  );
};
export default CustomerLocationTab;
